<template>
    <div class="card mb-3 flex-grow-1 w-100">
        <div class="card-body p-0 d-flex flex-column">
            <div class="d-flex flex-column flex-md-row flex-grow-1">
                <div class="plan-identity p-4 d-flex flex-column">
                    <div class="text-muted font-size-sm mb-1">{{ $t('paymentTable.currentTariff.title') }}</div>
                    <div class="d-flex align-items-baseline mb-2">
                        <h2 class="mb-0 mr-3 font-weight-semibold text-indigo" style="font-size: 32px; line-height: 1.1;">{{ tariff && tariff.name }}</h2>
                        <span :class="badgeClasses">
                            <i :class="iconClasses" style="font-size: 10px;"></i>{{ tariffIsActive ? $t('paymentTable.currentTariff.statusActive') : $t('paymentTable.currentTariff.statusInactive') }}
                        </span>
                    </div>
                    <div class="plan-expiry mt-1 mb-3">
                        <div class="plan-expiry-line">
                            <i class="icon-calendar22 plan-expiry-icon"></i>
                            <span class="plan-expiry-label">{{ $t('paymentTable.currentTariff.expiresLabel') }}</span>
                            <span class="plan-expiry-date">{{ tariffExpiryDate }}</span>
                        </div>
                        <div class="font-size-xs text-muted mt-1">{{ $t('paymentTable.currentTariff.daysRemaining', { days: daysRemaining }) }}</div>
                    </div>
                    <AppButton color="indigo" @click="$refs.tariffModal.show()">
                        <i class="icon-credit-card2 mr-2"></i>
                        {{ $t('paymentTable.currentTariff.payButton') }}
                    </AppButton>
                </div>
                <div class="p-4 flex-grow-1">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <h6 class="mb-0 font-weight-semibold">{{ $t('paymentTable.currentTariff.limitsTitle') }}</h6>
                    </div>
                    <div class="d-flex flex-column" style="gap: 18px;">
                        <LimitRow
                            icon="icon-cart2"
                            :label="$t('paymentTable.currentTariff.productsLabel')"
                            :count="productsCount"
                            :limit="tariff ? tariff.products_limit : 0"
                            :format-number="formatNumber"
                        />
                        <LimitRow
                            icon="icon-puzzle"
                            :label="$t('paymentTable.currentTariff.integrationsLabel')"
                            :count="integrationsCount"
                            :limit="tariff ? tariff.integrations_limit : 0"
                            :format-number="formatNumber"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <NewTariffModal ref="tariffModal" />
</template>
<script>
import AppButton from '../../../../../components/new/button/AppButton.vue';
import LimitRow from '../components/LimitRow.vue';
import NewTariffModal from '../modals/NewTariffModal.vue';

import DateFormatter from '../../../../../services/DateFormatter';

export default {
    name: "CurrentTariffCard",
    components: {
        AppButton, LimitRow, NewTariffModal
    },
    props: {
        tariff: {
            type: Object,
            default: null
        },
        tariffExpiredAt: {
            type: String,
            default: null
        },
        productsCount: {
            type: Number,
            default: 0
        },
        integrationsCount: {
            type: Number,
            default: 0
        },
        formatNumber: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            DateFormatter
        }
    },
    computed: {
        tariffIsActive() {
            if (this.tariffExpiredAt === null) {
                return true;
            }

            const expiredDate = new Date(this.tariffExpiredAt);
            const currentDate = new Date();

            return expiredDate > currentDate;
        },
        tariffExpiryDate() {
            if (this.tariffExpiredAt === null) {
                return this.$t('paymentTable.currentTariff.unlimited');
            }

            return this.DateFormatter.formatDate(this.tariffExpiredAt);
        },
        badgeClasses() {
            return {
                'badge': true,
                'badge-flat': true,
                'border-success': this.tariffIsActive,
                'text-success-600': this.tariffIsActive,
                'border-danger': !this.tariffIsActive,
                'text-danger-600': !this.tariffIsActive,
                'align-self-center': true
            };
        },
        iconClasses() {
            return {
                'icon-checkmark3': this.tariffIsActive,
                'icon-cross3': !this.tariffIsActive,
                'mr-1': true
            };
        },
        daysRemaining() {
            if (this.tariffExpiredAt === null) {
                return '∞';
            }

            const expiredDate = new Date(this.tariffExpiredAt);
            const currentDate = new Date();
            const millisecondsPerDay = 1000 * 60 * 60 * 24;
            const daysDifference = Math.ceil((expiredDate - currentDate) / millisecondsPerDay);

            return Math.max(0, daysDifference);
        }
    }
}
</script>
<style scoped>
/* Plan Card */
.plan-identity {
    background: linear-gradient(180deg, #F5F6FB 0%, #ECEEF8 100%);
    border-right: 1px solid #E0E3EF;
    width: 280px;
    flex-shrink: 0;
}
.plan-expiry {
    padding: 12px 14px;
    background: #fff;
    border: 1px solid #E0E3EF;
    border-radius: 6px;
}
.plan-expiry-line {
    display: flex;
    align-items: baseline;
    gap: 8px;
    line-height: 1.2;
}
.plan-expiry-icon {
    color: #999;
    font-size: 13px;
    flex-shrink: 0;
    transform: translateY(2px);
}
.plan-expiry-label {
    color: #999;
    font-size: 14px;
}
.plan-expiry-date {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -.005em;
    font-variant-numeric: tabular-nums;
}
</style>